import { INotification } from '@epi-models/components/Notifier';
import { ErrorPopup } from '@epi-models/components/ErrorPopup';

export const getErrorPopup = (state): ErrorPopup => state.overlays.errorPopup;

export const getNotifications = (state): INotification[] =>
  state.overlays.notifications;

export const getPasswordPopup = state => state.overlays.passwordPopup;

export const getPasswordPopupErrorMessage = (state): string =>
  state.overlays.errorMessage;
